export default {
	apiBase: '/api/v1/owner/',
	preUrl: '//www.yuntask.com'
}



// WEBPACK FOOTER //
// ./src/common/constant.js